const configPrueba = () => {
  const isPrueba = false;
  return isPrueba;
};
export default configPrueba;
